module.exports = __webpack_public_path__ + "static/img/help3.4dfcee62.png";